import axios from 'axios'
import {LeadStatusModel} from '../models/LeadStatusModel'

const API_URL = process.env.REACT_APP_API_URL

// Get lead statuses
export function getLeadStatuses(subscriberId: string, requestedPage: number) {
  return axios.get<LeadStatusModel[]>(`${API_URL}/Subscribers/${subscriberId}/leadStatuses`, {
    params: {
      'filter[limit]': 10,
      'filter[skip]': (requestedPage - 1) * 10,
      'filter[order]': 'id ASC',
    },
  })
}

// Create new lead status
export function createLeadStatus(subscriberId: string, data: {status: string}) {
  return axios.post(`${API_URL}/Subscribers/${subscriberId}/leadStatuses`, data)
}

// Update lead status
export function updateLeadStatus(subscriberId: string, statusId: string, data: any) {
  return axios.put(`${API_URL}/Subscribers/${subscriberId}/leadStatuses/${statusId}`, data)
}

// Delete lead status
export function deleteLeadStatus(subscriberId: string, statusId: string) {
  return axios.delete(`${API_URL}/Subscribers/${subscriberId}/leadStatuses/${statusId}`)
}
